import { useModal } from "mui-modal-provider";
import { DubDialog } from "../common/dialog";
import { appStore, playStore } from "../utils/redirect";

const QrDialog = (props) => {
  const { open, onClose } = props;
  return (
    <DubDialog
      size="regular"
      open={open}
      onClose={onClose}
      body={
        <div style={{ padding: "70px" }}>
          <img src="/img/download_qr.png" alt="" width="100%" />
        </div>
      }
    />
  );
};

const useDownload = () => {
  const { showModal } = useModal();
  const handleDownload = (locale) => {
    const isMobile = navigator.userAgent.match(
      /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/gi,
    );
    const isIos = navigator.userAgent.match(/iPhone|iPad|iPod/);
    if (!isMobile) {
      const modal = showModal(QrDialog, {
        onClose: () => {
          modal.destroy();
        },
      });
      return;
    }
    if (isIos) {
      appStore(locale);
    } else {
      playStore(locale);
    }
  };
  return { handleDownload };
};

export default useDownload;
